// utils/costUtils.js
export const parseCostString = (costString) => {
    if (!costString) return [];
    return costString.split('`').map(val => parseFloat(val) || 0);
};

export const getAverageCost = (costString) => {
    const costs = parseCostString(costString);
    if (costs.length === 0) return 0;
    const sum = costs.reduce((acc, val) => acc + val, 0);
    return (sum / costs.length).toFixed(2);
};

export const formatCostsForApi = (monthlyValues) => {
    return monthlyValues.join('`');
};

export const months = [
    {en: 'january', ru: 'Январь'},
    {en: 'february', ru: 'Февраль'},
    {en: 'march', ru: 'Март'},
    {en: 'april', ru: 'Апрель'},
    {en: 'may', ru: 'Май'},
    {en: 'june', ru: 'Июнь'},
    {en: 'july', ru: 'Июль'},
    {en: 'august', ru: 'Август'},
    {en: 'september', ru: 'Сентябрь'},
    {en: 'october', ru: 'Октябрь'},
    {en: 'november', ru: 'Ноябрь'},
    {en: 'december', ru: 'Декабрь'}
];

export const monthsShort = [
    'Янв', 'Фев', 'Мар', 'Апр', 'Май', 'Июн',
    'Июл', 'Авг', 'Сен', 'Окт', 'Ноя', 'Дек'
];